import { _ as _assign } from '../tslib.es6-c6da0ae6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { useTranslator } from '@picsart/rc/services/localization';
import { IconStarFilled } from '@picsart/design-system/foundation/icons/IconStarFilled';
import { HorizontalContainer } from '@picsart/design-system/components/HorizontalContainer';
import getMobileOperatingSystem from '@picsart/rc/getMobileOperatingSystem';
import { T as Title } from '../index-6f49f05f.js';
import { NegativeColors, BackgroundColors, SecondaryColors, AbsolutesWhiteColors } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';
import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';

var WindowsStore = ' WindowsStore';
var AndroidStore = 'Google Play';
var AppStore = 'App Store';

var data = {
  AppStoreText: 'Read more reviews on the App Store',
  AppStoreUrl: 'https://apps.apple.com/us/app/picsart-photo-studio/id587366035',
  AndroidStoreUrl: 'https://play.google.com/store/apps/details?id=com.picsart.studio',
  AndroidStoreText: 'Read more reviews on Google Play',
  WindowsStoreUrl: 'https://apps.microsoft.com/store/detail/9WZDNCRFJ10M?launch=true&mode=mini',
  WindowsStoreText: 'Read more reviews on Microsoft Store',
  reviews: [{
    title: 'Makes my life easier',
    content: 'I’ve been using it for about 2 years to make all the graphics for my small business. It’s reliable, effective and to the point. The background erasing tool solves a lot of problems and makes my life easier. I edit everything on the go.',
    name: 'Nadia T',
    large: true,
    date: '2023.01.12',
    rating: 5
  }, {
    title: 'Fantastic. Very user friendly',
    content: 'Fantastic. Very user friendly. Thanks to Picsart, anybody can generate images now!',
    name: 'Madan',
    date: '2023.01.12',
    rating: 5
  }, {
    title: 'Incredibly intuitive and easy to use',
    content: 'I have been using Picsart AI Photo Editor, Video & Collage Maker for the past few years and I love it is one of the most comprehensive photo editing apps I’ve seen, allowing me to make quick edits to my photos and videos, or more intricate edits using the various tools available. I especially appreciate the wide range of filter options, as well as the ability to create collages with multiple images. In addition, the app is incredibly intuitive and easy to use.',
    name: 'Pakelika',
    gradient: true,
    large: true,
    date: '2023.01.12',
    rating: 5
  }, {
    title: 'Best photo and video editor!',
    content: 'I love Picsart, is the best photo and video editor! It has new options daily and so many features. I highly recommend it. And it is very user friendly. Go for it! It is an amazing app!',
    name: 'Carina L',
    date: '2023.01.12',
    rating: 5
  }, {
    title: 'It’s my go-to app',
    content: 'I can’t get enough of Picsart! It’s my go-to app for adding that extra bit of flair to my photos.',
    name: 'Lauren',
    date: '2023.01.12',
    rating: 5
  }, {
    title: 'New designs, new features',
    content: 'I’ve been using Picsart for a long time, and it’s never boring for me, every week something new is coming: new designs, new features, new solutions.',
    name: 'Levon_Grigoryan',
    gradient: true,
    large: true,
    date: '2023.01.12',
    rating: 5
  }, {
    title: 'Helps you grow as an artist',
    content: 'The first thing I fell in love with, and why I continue to love Picsart, is the community itself. Encouragement from others is so valuable and helps you grow as an artist. And because we all have preferred tools and styles, being able to go through questions and experiences with other artists is really fun',
    name: '@hey_its_me_april',
    large: true,
    date: '2023.01.12',
    rating: 5
  }, {
    title: 'Extremely user friendly',
    content: 'Extremely user friendly, brilliant and top notch designs. It has every imaginable tool one can use in digital content designing.',
    name: 'Ashish',
    date: '2023.01.12',
    rating: 5
  }, {
    title: 'Very intuitive, very powerful',
    content: 'Great tool for photo editing, very intuitive, very powerful. Also, a lot of inspiration from others.',
    name: 'Geoff',
    date: '2023.01.12',
    rating: 5
  }, {
    title: 'The best photo editing app ever',
    content: 'This is by far the best photo editing app ever. There are so many different things filters options things can do that any other regular editing app doesn’t have. My gf and I have been using this app for years and the developers always find ways to make it better! We were also very happy with the Gold picsart paid version. way to go guys, keep up the good work!',
    name: 'Adam N',
    gradient: true,
    large: true,
    date: '2023.01.12',
    rating: 5
  }, {
    title: 'It’s always growing and improving',
    content: 'I’ve been using this program for years and love it! It’s always growing and improving. If you are looking for a photo editor to play around with or a little something extra for your business I would highly recommend giving this one a try!',
    name: 'Cathy',
    large: true,
    date: '2023.01.12',
    rating: 5
  }, {
    title: 'Stunning features',
    content: 'Stunning features and brilliant functionality packed in a neat, streamlined interface. thank you for this :)',
    name: 'Seth W',
    date: '2023.01.12',
    rating: 5
  }, {
    title: 'Extremely easy to use app',
    content: 'I use Picsart throughout the day, sometimes for work and sometimes for play. It is an extremely easy to use app and allows me to express my creativity in endless ways.',
    name: 'Ali',
    date: '2023.01.12',
    rating: 5
  }, {
    title: 'Hands-on learning experience',
    content: 'I had limited technical skills when I joined Spaces just a few months ago, and it’s been wonderful in providing a hands-on learning experience.',
    name: '@kaiakreations',
    large: true,
    date: '2023.01.12',
    rating: 5
  }, {
    title: 'Definitely worth the money',
    content: 'Definitely worth the money. There are so many features that you can’t get in the free apps. Trust me I’ve looked and compared!',
    name: 'Craig M',
    large: true,
    date: '2023.01.12',
    rating: 5
  }, {
    title: 'So many editing options',
    content: 'I have loved Picsart for over 10 years, maybe longer. It is EASY to use and chock full of so many editing options. The sky’s the limit. All it takes is your imagination!',
    name: 'Jackie J',
    date: '2023.01.12',
    rating: 5
  }, {
    title: 'Most intuitive, user friendly Editor',
    content: 'I don’t usually write reviews, but PicsArt is great. It’s by far the best photo editing app on Android',
    name: 'Nick',
    date: '2023.01.12',
    rating: 5
  }, {
    title: 'This app is perfect for me',
    content: 'Fantastic app for anyone who likes editing photos/graphic design. I’ve been using it for many months now and have only good things come from it. I enjoy writing and this app is perfect for me to make covers for the stories I made, and every cover I’ve made on here turned out great. I also like the wide variety of filters that you can use, even without premium you have plenty of options. Won’t be deleting any time soon, nothing like it.',
    name: 'Audrey',
    gradient: true,
    large: true,
    date: '2023.01.12',
    rating: 5
  }]
};

var _a;
var useStyles = createUseStyles({
  wrapper: {
    background: 'linear-gradient(218deg, rgba(0, 0, 0, 0.00) -2.84%, #5A00EE 105.79%)',
    backgroundColor: NegativeColors.base["default"],
    padding: [84, Spacings.s0],
    width: '100%',
    margin: [Spacings.s0, 'auto'],
    overflow: 'hidden',
    '@media screen and (max-width: 768px)': {
      padding: [Spacings.s48, Spacings.s0]
    }
  },
  topSection: {
    maxWidth: '80%',
    textAlign: 'center',
    margin: '0 auto',
    '& h2': {
      color: NegativeColors.text["default"],
      '& i': {
        color: function color(_a) {
          var titleColor = _a.titleColor;
          return titleColor || '#b995f3';
        },
        fontStyle: 'normal'
      }
    }
  },
  content: {
    overflowX: 'scroll',
    paddingLeft: Spacings.s64,
    marginTop: Spacings.s48,
    display: 'flex',
    gap: Spacings.s32,
    '-ms-overflow-style': 'none',
    scrollbarWidth: 'none',
    maxWidth: 2560,
    width: '100%',
    margin: [Spacings.s0, 'auto'],
    '@media screen and (max-width: 768px)': {
      gap: Spacings.s0,
      paddingLeft: Spacings.s24
    },
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },
  itemWrapper: {
    '@media screen and (max-width: 768px)': {
      display: 'flex'
    },
    '&:last-of-type': {
      paddingRight: Spacings.s64,
      '@media screen and (max-width: 768px)': {
        paddingRight: Spacings.s24
      }
    }
  },
  item: {
    position: 'relative',
    width: 430,
    height: 260,
    padding: Spacings.s32,
    background: BackgroundColors.base,
    borderRadius: CornerRadius.r20,
    marginBottom: Spacings.s32,
    '@media screen and (max-width: 768px)': {
      height: 368,
      width: 294,
      marginRight: Spacings.s24
    },
    '@media screen and (max-width: 520px)': {
      height: 354,
      width: 294,
      marginRight: Spacings.s24
    },
    '& strong': {
      marginTop: Spacings.s10,
      marginBottom: Spacings.s10,
      fontSize: FontSizes.s20,
      fontWeight: FontWeights.semibold,
      lineHeight: LineHeights.l28
    }
  },
  largeItem: {
    height: 368,
    '@media screen and (max-width: 768px)': {
      height: 354
    }
  },
  review: {
    '& > svg': {
      fill: (_a = SecondaryColors.alpha) === null || _a === void 0 ? void 0 : _a.alpha80
    }
  },
  itemContent: {
    fontSize: FontSizes.s16,
    fontWeight: FontWeights.medium,
    lineHeight: LineHeights.l24,
    overflowY: 'scroll',
    height: 96,
    '-ms-overflow-style': 'none',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    },
    '@media screen and (max-width: 768px)': {
      height: 144
    }
  },
  largeItemContent: {
    height: 170,
    '@media screen and (max-width: 768px)': {
      height: 144
    }
  },
  nameSection: {
    position: 'absolute',
    bottom: 28,
    fontSize: FontSizes.s16,
    fontWeight: FontWeights.semibold,
    lineHeight: LineHeights.l28
  },
  bgColor: {
    background: 'linear-gradient(270deg, #E395C5 -42.5%, #5A00EE 100%)',
    color: NegativeColors.text["default"],
    '& > div > svg': {
      fill: AbsolutesWhiteColors.base["default"],
      opacity: '0.5'
    }
  },
  appStoreLink: {
    display: 'none',
    color: NegativeColors.text["default"],
    fontSize: FontSizes.s16,
    fontWeight: FontWeights.semibold,
    lineHeight: LineHeights.l24,
    textAlign: 'center',
    marginTop: Spacings.s24,
    '@media screen and (max-width: 768px)': {
      display: 'block'
    }
  },
  skeletonTitle: {
    height: 142,
    maxWidth: 940,
    margin: [Spacings.s0, 'auto', Spacings.s56, 'auto']
  },
  skeletonItemWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: Spacings.s24
  },
  skeletonItem: {
    height: 368,
    width: 430
  }
}, {
  name: 'Review-scroller'
});

var operatingSystem = {
  IOS: 'iOS',
  WindowsPhone: 'WindowsPhone',
  Android: 'Android'
};
var ReviewScroller = function ReviewScroller(_a) {
  var _b = _a.AppStoreUrl,
    AppStoreUrl = _b === void 0 ? data.AppStoreUrl : _b,
    _c = _a.AndroidStoreUrl,
    AndroidStoreUrl = _c === void 0 ? data.AndroidStoreUrl : _c,
    _d = _a.AndroidStoreText,
    AndroidStoreText = _d === void 0 ? data.AndroidStoreText : _d,
    _e = _a.AppStoreText,
    AppStoreText = _e === void 0 ? data.AppStoreText : _e,
    _f = _a.reviews,
    reviews = _f === void 0 ? data.reviews : _f,
    _g = _a.WindowsStoreUrl,
    WindowsStoreUrl = _g === void 0 ? data.WindowsStoreUrl : _g,
    _h = _a.WindowsStoreText,
    WindowsStoreText = _h === void 0 ? data.WindowsStoreText : _h,
    title = _a.title,
    wrapperClassName = _a.wrapperClassName,
    cardClassName = _a.cardClassName,
    cardGradientClassName = _a.cardGradientClassName;
  var styles = useStyles({
    titleColor: title === null || title === void 0 ? void 0 : title.color
  });
  var deviceType = getMobileOperatingSystem(null);
  var translate = useTranslator();
  var columns = [];
  var storeLink = AppStoreUrl;
  var storeText = AppStoreText;
  var storeType = AppStore;
  for (var i = 0; i < (reviews === null || reviews === void 0 ? void 0 : reviews.length); i += 2) {
    columns.push(reviews.slice(i, i + 2));
  }
  if (deviceType === operatingSystem.WindowsPhone) {
    storeLink = WindowsStoreUrl;
    storeText = WindowsStoreText;
    storeType = WindowsStore;
  } else if (deviceType === operatingSystem.Android) {
    storeLink = AndroidStoreUrl;
    storeText = AndroidStoreText;
    storeType = AndroidStore;
  }
  return jsxs("div", _assign({
    className: classNames(styles.wrapper, wrapperClassName)
  }, {
    children: [jsx("div", _assign({
      className: styles.topSection,
      "data-testid": "main"
    }, {
      children: title && jsx(HorizontalContainer, {
        children: jsx(Title, _assign({}, title))
      })
    })), jsx("div", _assign({
      className: styles.content
    }, {
      children: columns && columns.map(function (column, index) {
        return jsx("div", _assign({
          className: styles.itemWrapper
        }, {
          children: column.map(function (item, itemIndex) {
            return jsxs("div", _assign({
              className: classNames(styles.item, item.large && styles.largeItem, item.gradient && styles.bgColor, item.gradient && cardGradientClassName, !item.gradient && cardClassName)
            }, {
              children: [jsxs("div", _assign({
                className: styles.review
              }, {
                children: [jsx(IconStarFilled, {}), jsx(IconStarFilled, {}), jsx(IconStarFilled, {}), jsx(IconStarFilled, {}), jsx(IconStarFilled, {})]
              })), jsx("strong", {
                children: translate(item.title)
              }), jsx("div", _assign({
                className: classNames(styles.itemContent, item.large && styles.largeItemContent)
              }, {
                children: jsx("p", {
                  children: translate(item.content)
                })
              })), jsx("div", _assign({
                className: styles.nameSection
              }, {
                children: jsx("p", {
                  children: translate(item.name)
                })
              }))]
            }), itemIndex);
          })
        }), index);
      })
    })), jsx("a", _assign({
      className: styles.appStoreLink,
      "data-pulse-name": storeType,
      href: storeLink,
      "data-testid": "app-store"
    }, {
      children: translate(storeText)
    }))]
  }));
};

var ReviewScrollerFallback = function ReviewScrollerFallback() {
  var styles = useStyles({
    titleColor: ''
  });
  return jsxs("i", _assign({
    "data-testid": "review-scroller-fallback"
  }, {
    children: [jsx("i", {
      className: classNames('skeleton', styles.skeletonTitle)
    }), jsxs("i", _assign({
      className: styles.skeletonItemWrapper
    }, {
      children: [jsx("i", {
        className: classNames('skeleton', styles.skeletonItem)
      }), jsx("i", {
        className: classNames('skeleton', styles.skeletonItem)
      }), jsx("i", {
        className: classNames('skeleton', styles.skeletonItem)
      }), jsx("i", {
        className: classNames('skeleton', styles.skeletonItem)
      }), jsx("i", {
        className: classNames('skeleton', styles.skeletonItem)
      }), jsx("i", {
        className: classNames('skeleton', styles.skeletonItem)
      })]
    }))]
  }));
};

export { ReviewScrollerFallback, ReviewScroller as default };
//# sourceMappingURL=index.js.map
